import { Skeleton, TableRow, TableCell, styled } from '@mui/material';

import { type ColumnVisibility } from './types';

const StyledTableCell = styled(TableCell)<{ width?: string }>`
    padding: 11px 16px;
    overflow: hidden;

    /* Apply width if provided */
    ${(props) =>
        props.width &&
        `
        width: ${props.width};
        min-width: ${props.width};
        max-width: ${props.width};
    `}
`;

const CheckboxLoadingCell = styled(TableCell)`
    padding: 11px 16px;
    width: 48px;
    min-width: 48px;
    max-width: 48px;
    text-align: center;
    overflow: hidden;
`;

const ClassNameLoadingCell = styled(TableCell)`
    padding: 11px 16px;
    width: 35%;
    min-width: 200px;
    overflow: hidden;
`;

const InstructorLoadingCell = styled(TableCell)`
    padding: 11px 16px;
    width: 25%;
    min-width: 150px;
    overflow: hidden;
`;

const DateLoadingCell = styled(TableCell)`
    padding: 11px 16px;
    width: 20%;
    min-width: 120px;
    overflow: hidden;
`;

const CreatedLoadingCell = styled(TableCell)`
    padding: 11px 16px;
    width: 15%;
    min-width: 100px;
    overflow: hidden;
`;

const ActionsLoadingCell = styled(TableCell)`
    padding: 11px 16px;
    width: 80px;
    min-width: 80px;
    max-width: 80px;
    overflow: hidden;
`;

interface LoadingTableRowsProps {
    columnVisibility: ColumnVisibility;
}

const LoadingTableRows = ({ columnVisibility }: LoadingTableRowsProps) => {
    const tableRows: any[] = [];

    for (let i = 0; i < 15; i++) {
        tableRows.push(
            <TableRow key={i}>
                {/* Checkbox column */}
                <CheckboxLoadingCell>
                    <Skeleton animation="wave" />
                </CheckboxLoadingCell>

                {/* Conditional columns based on visibility */}
                {columnVisibility.className && (
                    <ClassNameLoadingCell>
                        <Skeleton animation="wave" />
                    </ClassNameLoadingCell>
                )}
                {columnVisibility.instructor && (
                    <InstructorLoadingCell>
                        <Skeleton animation="wave" />
                    </InstructorLoadingCell>
                )}
                {columnVisibility.dates && (
                    <DateLoadingCell>
                        <Skeleton animation="wave" />
                    </DateLoadingCell>
                )}
                {columnVisibility.created && (
                    <CreatedLoadingCell>
                        <Skeleton animation="wave" />
                    </CreatedLoadingCell>
                )}

                {/* Actions column - always visible */}
                <ActionsLoadingCell>
                    <Skeleton animation="wave" />
                </ActionsLoadingCell>
            </TableRow>
        );
    }

    return <>{tableRows}</>;
};

export default LoadingTableRows;
